import { Typography } from 'antd';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * «Ввёл: X · Утвердил: Y · Провёл: Z» under a money row / накладная — who is
 * behind it, read from the audit trail. Renders nothing when no name is known
 * (rows older than the audit trail, MoySklad-synced documents).
 */
export function ActorLine({
  enteredBy,
  approvedBy,
  postedBy,
  createdBy,
  style,
}: {
  enteredBy?: string | null;
  approvedBy?: string | null;
  postedBy?: string | null;
  createdBy?: string | null;
  style?: React.CSSProperties;
}): JSX.Element | null {
  const { t } = useTranslation();
  const parts = [
    enteredBy ? t('common.enteredBy', { name: enteredBy }) : null,
    approvedBy ? t('common.approvedBy', { name: approvedBy }) : null,
    createdBy ? t('shipments.createdBy', { name: createdBy }) : null,
    postedBy ? t('shipments.postedBy', { name: postedBy }) : null,
  ].filter((p): p is string => p !== null);
  if (parts.length === 0) return null;
  return (
    <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12, ...style }}>
      {parts.join(' · ')}
    </Typography.Text>
  );
}
